import React from 'react';

const Mailjet = () => {
  return (
    <>
      <iframe
        data-w-type='embedded'
        frameborder='0'
        scrolling='no'
        marginheight='0'
        marginwidth='0'
        src='https://892s.mjt.lu/wgt/892s/iiu/form?c=98557600'
        width='100%'
        style={{ height: 0 }}
      />

      <script
        type='text/javascript'
        src='https://app.mailjet.com/pas-nc-embedded-v1.js'
      ></script>
    </>
  );
};

export default Mailjet;
